import { render, staticRenderFns } from "./ImportarProcessosDigitalizados.vue?vue&type=template&id=03ad15c0&"
import script from "./ImportarProcessosDigitalizados.vue?vue&type=script&lang=js&"
export * from "./ImportarProcessosDigitalizados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports